import {
  RETRIEVE_FEED_DETAILS_BEGIN,
  RETRIEVE_FEED_DETAILS_SUCCESS,
  RETRIEVE_FEED_DETAILS_FAILURE,
  POSITIVE,
  NEGATIVE,
  ALL
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

export function retrieveFeedDetails(props = {}) {
  return dispatch => {
    dispatch({
      type: RETRIEVE_FEED_DETAILS_BEGIN,
      data: props.pageId,
    });

    var url = '';
    if (props.sentiment === POSITIVE || props.sentiment === NEGATIVE) {
      url = `${apiEndPoints.feeds.RETRIEVE_FEED_DETAILS}?feedId=${props.feedId}&sentiment=${props.sentiment},very ${props.sentiment}&sortType=${props.sortType}&pageLimit=${props.pageLimit}&pageId=${props.pageId}&minSarcasmScore=${props.minSarcasmScore}&maxSarcasmScore=${props.maxSarcasmScore}`;
    }
    else if (props.sentiment === ALL) {
      url = `${apiEndPoints.feeds.RETRIEVE_FEED_DETAILS}?feedId=${props.feedId}&sortType=${props.sortType}&pageLimit=${props.pageLimit}&pageId=${props.pageId}&minSarcasmScore=${props.minSarcasmScore}&maxSarcasmScore=${props.maxSarcasmScore}`;
    }
    else {
      url = `${apiEndPoints.feeds.RETRIEVE_FEED_DETAILS}?feedId=${props.feedId}&sentiment=${props.sentiment}&sortType=${props.sortType}&pageLimit=${props.pageLimit}&pageId=${props.pageId}&minSarcasmScore=${props.minSarcasmScore}&maxSarcasmScore=${props.maxSarcasmScore}`;
    }

    const promise = new Promise((resolve, reject) => {
      const doRequest = http.get(url);
      doRequest.then(
        res => {
          dispatch({
            type: RETRIEVE_FEED_DETAILS_SUCCESS,
            data: { count: res.data.count, data: res.data.data, pageId: props.pageId, filteredCommentCounts: res.data.filteredCommentCounts },
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: RETRIEVE_FEED_DETAILS_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RETRIEVE_FEED_DETAILS_BEGIN:
      return {
        ...state,
        retrieveFeedsDetailsBegin: true,
        retrieveFeedsDetailsSuccess: false,
        retrieveFeedsDetailsFailure: false,
        feedDetails: action.data === 1 ? {} : state.feedDetails,
      };
    case RETRIEVE_FEED_DETAILS_SUCCESS:
      const { feedDetails } = state;
       
      const updatedFeedDetails =
        action.data.pageId > 1
          ? [...feedDetails.data, ...action.data.data ]
          : action.data.data ;
      return {
        ...state,
        retrieveFeedsDetailsBegin: false,
        retrieveFeedsDetailsSuccess: true,
        feedDetails: { data: updatedFeedDetails, count: action.data.count, filteredCommentCounts: action.data.filteredCommentCounts },
      };
    case RETRIEVE_FEED_DETAILS_FAILURE:
      return {
        ...state,
        retrieveFeedsDetailsBegin: false,
        retrieveFeedsDetailsFailure: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/retrieveFeedDetails.js